
export default function() {
  $(".menu-handle").click(function(e) {
    e.preventDefault();
    $(".main-menu").addClass("show");
  });
  $(".main-menu .close").click(function(e) {
    e.preventDefault();
    $(".main-menu").removeClass("show");
  });

  
  
  // var mainMenuBg=$("<span>", {class: "bg"}).appendTo(".main-menu");
  var hasTouch=false;
  $(document).on("touchstart", function(e) {
    hasTouch=true;
  });
  $(".main-menu").mousemove(function(e) {
    if (hasTouch)
      return;
    var x=Math.round(e.pageX/this.clientWidth*50-25);
    var y=Math.round(e.pageY/this.clientHeight*50-25);
//     console.log("calc(50% + "+x+"px) calc(50% + "+y+"px)");
    // mainMenuBg.css("background-position", "calc(50% + "+x+"px) calc(50% + "+y+"px)");
//     console.log(e.pageX, e.pageY, this.clientWidth, this.clientHeight);
  });
  
  
  // eyes animation
  var eyes=$(".otto-anim span");
  var eyesIn=$(".otto-anim span em");
  $(".main-menu").mousemove(function(e) {
    if (hasTouch)
      return;
    
//     var x=Math.round(e.pageX/this.clientWidth*50-25);
//     var y=Math.round(e.pageY/this.clientHeight*50-25);
    for(var i=0;i<2;i++) {
      var eyeOffset=eyes.eq(i).offset();
      var evX=e.pageX-eyeOffset.left-eyes.eq(i).innerWidth()/2;
      var evY=e.pageY-eyeOffset.top-eyes.eq(i).innerHeight()/2;
      var distance=Math.sqrt(evX*evX+evY*evY);
      var maxDistance=eyes.eq(i).innerWidth()/3;

      var x=Math.round(evX)/(Math.max(maxDistance, distance)/maxDistance);
      var y=Math.round(evY)/(Math.max(maxDistance, distance)/maxDistance);
      eyesIn.eq(i).css("transform", "translate("+x+"px, "+y+"px)");
    }

  });
  
}
